module.exports = __webpack_public_path__ + "static/media/cq_editor_intestazione4.2d4dafa1.svg";